/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ClassifierCategory {
    NONE = 'none',
    INSTITUTION = 'institution',
    DIAGNOSTIC = 'diagnostic',
    PERSONS = 'persons',
    TREATMENT = 'treatment',
    INVESTIGATIONS = 'investigations',
    STOCKS = 'stocks',
    REPORTS = 'reports',
    SCREENING = 'screening',
}
